/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Sync_Field_External_IdInputs */

const en_po_sync_field_external_id = /** @type {(inputs: Po_Sync_Field_External_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order in Business Central`)
};

/**
* | output |
* | --- |
* | "Order in Business Central" |
*
* @param {Po_Sync_Field_External_IdInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_sync_field_external_id = /** @type {((inputs?: Po_Sync_Field_External_IdInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Sync_Field_External_IdInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_sync_field_external_id(inputs)
});